module.exports = __webpack_public_path__ + "img/kasagame-logo.e3b9e455.svg";